import { useContext, memo, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { useLanguage } from '@languages/index';
import { CAMPAIGN_UPDATE_FORM_TYPE } from 'constants/campaign';
import Button from '@components/button';
import { CampaignFormContext } from '../../../../campaignForm.context';

interface CampaignFormStepButtonProps {
  disabledNextButton?: boolean;
  onClickNext: () => void;
}

const CampaignFormStepButtons = ({
  onClickNext,
  disabledNextButton = false,
}: CampaignFormStepButtonProps) => {
  const location = useLocation();
  const language = useLanguage();
  const languageTexts = { ...language.common, ...language.pages.campaigns };
  const { updateCampaignId, step, setStep } = useContext(CampaignFormContext);

  const hidePrevButton = useMemo(() => {
    return (
      // 1단계인 경우
      step <= 1 ||
      // 마스터 캠페인 수정 페이지 진입 시 2단계까지 prev 버튼 숨김
      (location?.search?.includes(CAMPAIGN_UPDATE_FORM_TYPE.MASTER) &&
        step <= 2)
    );
  }, [step, location?.search]);

  return (
    <>
      {step <= 3 && (
        <div className="static md:fixed bottom-0 left-0 right-0 md:left-auto form-submit-button md:rounded-sm md:mr-8 md:mb-6 z-[1]">
          <div className="submit flex flex-row gap-3">
            {!hidePrevButton && (
              <Button
                className="md:min-w-[240px] px-4 py-3 justify-center text-center bg-white"
                text={languageTexts.button_prev_1}
                onClick={() => setStep((prevStep) => prevStep - 1)}
              />
            )}
            <Button
              className="md:min-w-[240px] px-4 py-3 justify-center text-center"
              buttonColor={!disabledNextButton ? 'BLACK' : '#919191'}
              borderColor={!disabledNextButton ? 'BLACK' : '#919191'}
              textColor="white"
              text={
                updateCampaignId
                  ? languageTexts.button_next_1
                  : languageTexts.create_next_step_with_saving
              }
              onClick={() => {
                if (!disabledNextButton) {
                  onClickNext();
                }
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default memo(CampaignFormStepButtons);
